<template>
  <TemplateDbsBookingConfirmation v-if="isReadyToDraw" :pageType="pageType" />

  <DialogInitialLoading v-else :onClose="returnNativeDbsIndexPage" />

  <!-- 指定した自転車がない場合 -->
  <DialogNoCycle ref="DialogNoCycle" />

  <!-- 選択した自転車が対象外のエリアの自転車の場合 -->
  <DialogInvalidArea ref="DialogInvalidArea" />
</template>

<script>
import { onMounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";

import API from "@/API";
import dbsService from "@/services/dbs";
import nativeHandlerService from "@/services/nativeHandler";
import userInfoService from "@/services/userInfo";
import TemplateDbsBookingConfirmation from "@/views/Templates/Dbs/TemplateDbsBookingConfirmation";

export default {
  name: "DbsBookingConfirmation",
  components: {
    TemplateDbsBookingConfirmation,
  },
  setup() {
    const route = useRoute();
    const isReadyToDraw = ref(false);
    const pageType = route.query.type;

    const DialogNoCycle = ref(null);
    const DialogInvalidArea = ref(null);

    // 未ログイン or クレカ未登録時にTOPへ戻る
    const returnNativeDbsIndexPage = () => {
      nativeHandlerService.returnNativeDbsIndexPage();
    }

    const getCycle = async() => {
      if (route.query.cyc_name) {
        // 選択式の場合
        await API.getDbsCycle(0, route.query.cyc_name);
      } else if (route.query.cyc_csa_name) {
        // QRの場合
        await API.getDbsCycle(1, route.query.cyc_csa_name);
      }
    }

    const getCouponAndDrawIfCycleAvailable = async() => {
      if(dbsService.isAvailableCycle()){
        await API.getDbsCouponTickets();
        isReadyToDraw.value = true;
      }else{
        DialogInvalidArea.value.openDialog();
      }
    }

    onMounted(async () => {
      // 未ログイン or クレカ未登録時は継続不可(QR読み取りから遷移する場合があるので、描画時にチェック)
      // クレカチェックでログインもあわせて確認できる
      if(await userInfoService.checkCreditCard()){        
        try {
          await getCycle();
          await getCouponAndDrawIfCycleAvailable();
        } catch (e) {
          // ポートに自転車がない場合などはエラーとなるので、ダイアログ表示
          DialogNoCycle.value.openDialog();
          console.log("Error in DbsBookingConfirmation.onMounted()", e);
        }
      }else{
        // ダイアログを閉じたときのために、5秒後に一覧にリダイレクト
        setTimeout(() => {
          returnNativeDbsIndexPage();
        }, 5000);
        return;
      }
    });

    return {
      isReadyToDraw,
      pageType,
      DialogNoCycle,
      DialogInvalidArea,
      returnNativeDbsIndexPage,
    };
  },
};
</script>
